<div class="px-2 pt-2 pb-2">
  <app-filter-card
    [ngStyle]="{ display: showFilterCard ? '' : 'none' }"
    [manager]="filterCardManager"
  ></app-filter-card>

  <app-items-kpi-cards
    [filterCardData$]="filterCardData$"
    [boardTreeStructure]="boardTreeStructure"
    (kpiCardSelected)="onKpiCardSelected($event)"
  ></app-items-kpi-cards>

  <div class="items-view" [class.items-view-expanded]="!showFilterCard">
    <app-items-datatable
      *ngIf="filterCardData$.value?.itemView === 'list'"
      [boardTreeStructure]="boardTreeStructure"
      [filterCardData$]="filterCardData$"
    ></app-items-datatable>

    <app-items-kanban
      *ngIf="filterCardData$.value?.itemView === 'kanban'"
      [boardKey]="boardKey()"
      [boardTreeStructure]="boardTreeStructure"
      [filterCardData$]="filterCardData$"
    ></app-items-kanban>

    <app-items-kamishibai
      *ngIf="filterCardData$.value?.itemView === 'kamishibai'"
      [boardTreeStructure]="boardTreeStructure"
      [filterCardData$]="filterCardData$"
      (dateRangeChange)="onKamishibaiDateRangeChange($event)"
    ></app-items-kamishibai>
  </div>
</div>
